import FormattedMessage from 'I18n/components/FormattedMessage';
import { UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const ApprovalRequestAccessSuccessAlert = props => {
  const {
    approvalType
  } = props;
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.successAlert.message.MARKETING_EMAIL"
        });
      }
    case 'LANDING_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.successAlert.message.LANDING_PAGE"
        });
      }
    case 'SITE_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.successAlert.message.SITE_PAGE"
        });
      }
    case 'BLOG_POST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.successAlert.message.BLOG_POST"
        });
      }
    case 'DEAL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.successAlert.message.DEAL"
        });
      }
    case 'KNOWLEDGE_ARTICLE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.successAlert.message.KNOWLEDGE_ARTICLE"
        });
      }
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
};
export default ApprovalRequestAccessSuccessAlert;